/* PagingOsCatalogFeed.js */

"use strict";
const PagingFeed = require("../../../../lib/PagingFeed");
//const _ = require('lodash');

class PagingOsCatalogFeed extends PagingFeed {
    _getFeed() {
        return this._EntityDef.startOsImageCatalogsFeed(this._userSession.activeOrganization.id, this._filter, this._entityFields, this._sort, {
            skip: 0,
            limit: this._pageSize * 2
        });
    }

    _getFeedIdsForSelection(tenantId, selection) {
        return this._EntityDef.loadOsImageCatalogIdsForSelection(tenantId, selection);
    }

    _getSkuCount() {
        return this._EntityDef.skuCount;
    }

    getCatalogEntitiesById(ids) {
        return this.getEntitiesByIdAsProm(ids);
    }

    getCatalogEntitiesNameById(ids) {
        return this.getEntitiesValueByIdAsProm(ids, "name");
    }

    getOsCatalogEntityById(id) {
        return this.getEntityById(id);
    }
}

module.exports = PagingOsCatalogFeed;
